import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { MonthOptions, YearOptions } from "../config/functions";
import "../styles/EmployeeReportFilter.css";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";

interface FilterProps {
  filters: {
    year: string;
    month: string;
    employeeId: string;
  };
  onFilterChange: (filters: {
    year: string;
    month: string;
    employeeId: string;
  }) => void;
  onReset: () => void;
}

const SalaryMasterLogFilter: React.FC<FilterProps> = ({
  filters,
  onFilterChange,
  onReset,
}) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const salaryLog = useSelector((state: StoreState) => state.salaryMasterLog);

  const yearOptions = YearOptions().map((opt) => ({
    id: opt.value,
    name: opt.label,
  }));
  const monthOptions = MonthOptions().map((opt) => ({
    id: opt.value,
    name: opt.label,
  }));

  // Filter salary data based on year & month
  const filteredSalaries = salaryLog.filter((item) => {
    // Use createTimestamp consistently with EmployeeSalaryPage because in parent we filter using timeStamp
    const date = new Date(item.createTimestamp);
    const itemYear = date.getFullYear().toString();
    const itemMonth = (date.getMonth() + 1).toString().padStart(2, "0");

    return (
      (!localFilters.year || itemYear === localFilters.year) &&
      (!localFilters.month || itemMonth === localFilters.month)
    );
  });

  const employeeIds = filteredSalaries
    .map((s) => s.employeeId)
    .filter((id, index, self) => id && self.indexOf(id) === index);

  const uniqueEmployeeIds = employeeIds.map((id) => ({
    id,
    name: id.toString(),
  }));

  const handleInputChange = (name: string, value: string) => {
    const updatedFilters = { ...localFilters, [name]: value };
    setLocalFilters(updatedFilters);
  };

  //   const handleReset = () => {
  //     setLocalFilters({ year: '', month: '' });
  //     onReset();
  //   };

  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const renderDropdown = (
    label: string,
    name: string,
    value: string,
    options: { id: string; name: string }[],
  ) => (
    <Form.Group
      as={Col}
      xs={6}
      sm={4}
      md={3}
      lg={2}
      className="task-filter-field"
      controlId={name}
    >
      <div className="dropdown-label">{label}</div>
      <Form.Select
        value={value}
        onChange={(e) => handleInputChange(name, e.target.value)}
        className="custom-select"
      >
        <option value="">All</option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );
  return (
    <Form className="task-filter-form">
      <Row className="g-2 align-items-end">
        {renderDropdown("year", "year", localFilters.year, yearOptions)}
        {renderDropdown("month", "month", localFilters.month, monthOptions)}
        {renderDropdown(
          "Employee ID",
          "employeeId",
          localFilters.employeeId,
          uniqueEmployeeIds,
        )}

        <Col className="d-flex justify-content-end align-items-center">
          <Button
            variant="primary"
            className="mr-2"
            onClick={() => onFilterChange(localFilters)}
          >
            Find
          </Button>
          <Button variant="secondary" onClick={onReset}>
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default SalaryMasterLogFilter;
